import { useState, useEffect } from 'react'
import { BaseModal } from './BaseModal'
import { getUserProfile } from '../../lib/userProfile'
import { DisplayNameInput } from '../profile/DisplayNameInput'

type Props = {
  isOpen: boolean
  handleClose: () => void
  onConfirm: () => void
  onDecline: () => void
  userId: string
}

export const FairPlayModal = ({
  isOpen,
  handleClose,
  onConfirm,
  onDecline,
  userId,
}: Props) => {
  const [displayName, setDisplayName] = useState('')
  const [needsDisplayName, setNeedsDisplayName] = useState(false)

  useEffect(() => {
    if (isOpen && userId) {
      getUserProfile(userId).then((profile) => {
        if (profile?.displayName) {
          setDisplayName(profile.displayName)
          setNeedsDisplayName(false)
        } else {
          setNeedsDisplayName(true)
        }
      })
    }
  }, [isOpen, userId])

  const handleConfirm = () => {
    if (needsDisplayName && !displayName) {
      // DisplayNameInput component will show error
      return
    }
    onConfirm()
    handleClose()
  }

  return (
    <BaseModal
      title="🏆 Bekerülsz a ranglistára!"
      isOpen={isOpen}
      handleClose={handleClose}
      preventBackdropClose={true}
      zIndex={1020}
    >
      <div className="text-gray-700 dark:text-gray-300">
        <p className="pb-4">Gratulálunk a megoldáshoz! 🎉</p>

        {needsDisplayName && (
          <div className="mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Add meg a neved a ranglistán való megjelenéshez:
            </p>
            <DisplayNameInput
              userId={userId}
              currentDisplayName={displayName}
              onProfileUpdate={(newName) => {
                setDisplayName(newName)
                setNeedsDisplayName(false)
              }}
              compact={true}
            />
          </div>
        )}

        <div className="bg-amber-50 dark:bg-amber-800/30 rounded-lg p-4 mb-4">
          <p className="text-sm mb-3">
            Ahhoz, hogy az eredményed bekerüljön a heti bajnokságba és a szobáid
            ranglistáira, kérjük, erősítsd meg:
          </p>
          <p className="text-center text-base font-medium italic text-gray-900 dark:text-white">
            "Becsületszavamra, a mai feladványt nem ismertem előre, és senki nem
            súgta meg nekem a megoldást."
          </p>
        </div>

        <div className="flex gap-3 mt-4">
          <button
            type="button"
            className="flex-1 rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-3 bg-white dark:bg-gray-700 text-base font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={() => {
              onDecline()
              handleClose()
            }}
          >
            Nem számít bele
          </button>
          <button
            type="button"
            className="flex-1 rounded-md border border-transparent shadow-sm px-4 py-3 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400 disabled:cursor-not-allowed"
            onClick={handleConfirm}
            disabled={needsDisplayName && !displayName}
          >
            ✓ Megerősítem
          </button>
        </div>

        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 text-center">
          Ha nem erősíted meg, a megoldásod nem kerül be a ranglistákba, de a
          személyes statisztikádba igen.
        </p>
      </div>
    </BaseModal>
  )
}
